import { buttonVariants } from '@/components/shadcn/button'
import { motion } from 'motion/react'
import { Link } from 'react-router'
import { FeaturedAppCard } from '../FeaturedAppCard'
import { LandingSection } from '../LandingSection'
import { ApplicationMarketingCard } from '../selectFeaturedApps'

export function FeaturedAppsSection({ apps }: { apps: ApplicationMarketingCard[] }) {
  return (
    <LandingSection
      id="featured-apps"
      className="bg-offwhite"
      eyebrow="Catalogue"
      title="Featured apps"
      description="A selection of live apps on the platform. Open any card for a fuller picture, or browse the full catalogue."
    >
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {apps.map((app, index) => (
          <motion.div
            key={app.app_id}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.45, delay: index * 0.04 }}
          >
            <FeaturedAppCard app={app} />
          </motion.div>
        ))}
      </div>
      <div className="mt-10">
        <Link to="/featured-apps" className={buttonVariants({ variant: 'outline', size: 'lg' })}>
          See all apps
        </Link>
      </div>
    </LandingSection>
  )
}
